import { Spin } from 'antd';
import styles from './styles.module.scss';

export const Loading = ({ isHeightAuto }) => {
  return (
    <div className={`${styles.loadingContainer} ${isHeightAuto ? styles.loadingContainerAuto : ''}`}>
      <Spin />
    </div>
  );
};
